import { Logger } from '@sitecore-search/common';
import { buildRequestObject, filterSchemaFormatter } from './eventUtils.js';
import { trackSearchClickEntityEvent, trackSearchSuggestionClickEvent } from './widgetEvents.js';
/**
 * @desc Sent when users clicks Preview Search Widget entity
 * @param rfkId
 * @param entity
 * @param object: manage extra preview search event fields
 * @returns {Promise<*>}
 */
export const trackPreviewSearchClickEvent = async (rfkId, entity, { index, items, ...request }) => {
    if (!rfkId) {
        Logger.warn('trackEvent :::', `Widget's rfkId mandatory field is empty`);
        return;
    }
    return await trackSearchClickEntityEvent(rfkId, entity, {
        actionCause: 'entity',
        index,
        items,
        request: buildRequestObject(request),
    });
};
/**
 * Sent when users clicks Preview Search Widget category, keyphrase or any suggestion
 * @param rfkId
 * @param entity
 * @param object: manage extra preview search event fields
 * @returns {Promise<*>}
 */
export const trackPreviewSearchSuggestionClickEvent = async (rfkId, entity, { filters, ...request }) => {
    if (!rfkId) {
        Logger.warn('trackEvent :::', `Widget's rfkId mandatory field is empty`);
        return;
    }
    return await trackSearchSuggestionClickEvent(rfkId, entity, {
        ...(filters ? { filters: filterSchemaFormatter(filters) } : {}),
        request: buildRequestObject(request),
    });
};
